<template lang="html">
  <el-card shadow="always" body-style="padding:0px;width:100%;">
    <div :id="params.id" :style="params.chartHeight"></div>
    <div :id="params.id + '_table'" class="echart_table">
      <div style="width: 100%; height: 34px; line-height: 34px">
        <div style="width: 60px; float: left; text-align: center">
          <i @click="downloadData(params.id)" class="fa fa-download searchFilerCls" aria-hidden="true" title="导出"></i>
        </div>
        <el-row :gutter="15" style="width: calc(100% - 60px); float: left">
          <el-col
            v-for="(key, index) in Object.keys(params.columnMap[params.id])"
            :key="key"
            :span="Object.keys(params.columnMap[params.id]).length <= 4 ? 6 : 4">
            <el-input
              v-model="queryFilter[key]"
              clearable
              size="mini"
              :placeholder="'请输入' + params.columnMap[params.id][key]"
              style="margin-top: 0px; margin-bottom: 3px"
              class="searchInput">
              <el-button @click="searchData(params.id)" slot="append" size="mini" icon="el-icon-search"></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <table
        :id="params.id + '_tab'"
        style="width: 100%"
        class="tabletemp table-striped table-bordered tabletemp-hover">
        <thead>
          <tr>
            <th>
              <div title="返回" class="th-inner" style="text-align: center" @click="backEcharts(params.id)">
                <i class="fa fa-mail-reply" style="font-size: 16px; color: #55d3d3"></i>
              </div>
              <div class="fht-cell"></div>
            </th>
            <th v-for="(key, index) in Object.keys(params.columnMap[params.id])" :key="key" nowrap="nowrap">
              <div class="th-inner text-warning">
                {{ params.columnMap[params.id][key] }}
                <i
                  @click="sortData(params.id, key, querySort[params.id][key])"
                  :class="
                    querySort[params.id][key] == 'sort'
                      ? 'fa fa-sort'
                      : querySort[params.id][key] == 'asc'
                      ? 'fa fa-sort-asc'
                      : querySort[params.id][key] == 'desc'
                      ? 'fa fa-sort-desc'
                      : ''
                  "
                  :style="querySort[params.id][key] == 'sort' ? 'color: #e3dfdfff' : ''"></i>
              </div>
              <div class="fht-cell">
                <el-input
                  v-if="queryVisible[params.id]"
                  v-model="queryFilter[key]"
                  clearable
                  size="mini"
                  placeholder="请输入内容"
                  class="searchInput">
                  <el-button @click="searchData(params.id)" slot="append" size="mini" icon="el-icon-search"></el-button>
                </el-input>
              </div>
            </th>
          </tr>
        </thead>
        <tbody :id="params.id + '_html'" style="font-size: 14px !important">
          <tr>
            <td style="text-align: center; vertical-align: middle" colspan="99">加载中...</td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-card>
</template>

<script>
import * as echarts from "echarts";
const XLSX = require("xlsx");
import vintage from "echarts/theme/vintage.js";
import macarons from "echarts/theme/macarons.js";
import macarons2 from "echarts/theme/macarons2.js";
import blue from "echarts/theme/blue.js";
import cool from "echarts/theme/cool.js";
import forest from "echarts/theme/forest.js";
import fruit from "echarts/theme/fruit.js";
import green from "echarts/theme/green.js";
import roma from "echarts/theme/roma.js";
import shine from "echarts/theme/shine.js";
import london from "echarts/theme/london.js";
import infographic from "echarts/theme/infographic.js";
import chartFinance from "@/components/ChartFinance/StatisticalFinance.vue";
import provinceFinance from "@/components/ChartFinance/ProvinceFinance.vue";

import { getChartData2, listData } from "../../api/adminRole/statisticsAnalysis";
import { isEmpty } from "validate.js";
import moment from "moment";
export default {
  props: [
    "params",
    "searchData",
    "queryFilter",
    "queryVisible",
    "querySort",
    "sortData",
    "downloadData",
    "chartResize",
    "backEcharts",
    "setDisplayVisible",
    "createDataHtml",
    "setQueryVisible",
    "listTableData",
  ],
  data() {
    return {};
  },
  methods: {
    //柱图 横柱 叠加图
    chart_3(id, data) {
      let that = this;
      this.disposeChart(id);
      let names = [];
      let values1 = [];
      let values2 = [];
      let json = {};
      for (var index in data.data) {
        var item = data.data[index];
        json[item.name] = item.value;
      }
      if (id == "chart_31") {
        let szzNums = Number(json["音电中级职称人数"]);
        let comNums = Number(json["中级职称人数"]);
        let yxNums = Number(json["音像中级职称人数"]);
        let dzNums = Number(json["电子中级职称人数"]);
        let nums = Number(yxNums) - Number(dzNums);
        names = ["音电中级职称人数", "电子中级职称", "音像中级职称"];
        values1 = [comNums, szzNums, szzNums];
        values2 = [0, dzNums - szzNums, yxNums - szzNums];

        let txtNums = [comNums, szzNums, yxNums - szzNums, dzNums - szzNums, yxNums, dzNums];
        this.txtNums = txtNums;
      } else {
        let szzNums = Number(json["双资质"]);
        let comNums = Number(json["单位数量"]);
        let yxNums = Number(json["音像"]);
        let dzNums = Number(json["电子"]);
        let nums = Number(yxNums) - Number(dzNums);
        names = ["单位数量", "电子", "音像"];
        if (nums > 0) {
          values1 = [comNums, szzNums, szzNums];
          values2 = [0, dzNums - szzNums, yxNums - szzNums];
        } else {
          values1 = [comNums, szzNums, szzNums];
          values2 = [0, dzNums - szzNums, yxNums - szzNums];
        }
        let txtNums = [comNums, szzNums, yxNums - szzNums, dzNums - szzNums, yxNums, dzNums];
        this.txtNums = txtNums;
      }
      var myChart = echarts.init(document.getElementById(id), this.params.chartTheme);
      var option = {
        title: {
          text: data.title,
          subtext: data.subtext,
          left: "center",
          top: 30,
        },
        grid: {
          top: 80,
          bottom: 60,
          left: 40,
          containLabel: true,
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: {show: true, readOnly: true},
            myTool1: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "数据列表", // 鼠标移动上去显示的文字
              icon: that.params.imgUrldata, // 图标
              option: {},
              onclick: function (option1) {
                that.listTableData(id, myChart, option1);
              },
            },
            myTool2: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "放大显示", // 鼠标移动上去显示的文字
              icon: that.params.imgUrlfdj, // 图标
              option: {},
              onclick: function (option1) {
                that.listTableData(id, null, option);
              },
            },
            saveAsImage: { show: true, icon: that.params.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: names,
        },
        series: [
          {
            type: "bar",
            barMaxWidth: 30,
            avoidLabelOverlap: false,
            stack: "总量",
            label: {
              show: true,
              position: "inside",
              formatter(param) {
                return param.value == 0 ? "" : param.value;
              },
            },
            // labelLine: {
            //   length: 8,
            //   length2: 8,
            //   maxSurfaceAngle: 80
            // },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: "bold",
              },
            },
            // color:['#4FA1F3','#C976F4'],
            data: values1,
          },
          {
            type: "bar",
            barMaxWidth: 30,
            avoidLabelOverlap: false,
            stack: "总量",
            label: {
              show: true,
              position: "inside",
              formatter(param) {
                return param.value == 0 ? "" : param.value;
              },
            },
            labelLine: {
              length: 8,
              length2: 8,
              maxSurfaceAngle: 80,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: "bold",
              },
            },
            // color:['#4FA1F3','#C976F4'],
            data: values2,
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
  },
  mounted() {
    this.chart_3(this.params.id, this.params.data[this.params.id] || []);
  },
  created: function () {},
};
</script>

<style lang="scss" scoped>
.province-F {
  padding: 9px;
}
.echart_table {
  height: 420px;
  width: 100%;
  overflow: hidden;
  display: none;
}
.el-checkbox + .el-checkbox {
  margin-left: 15px;
}
.el-checkbox__label {
  padding-left: 4px !important;
}

.searchInput {
  margin-top: 6px;
}

.searchInputN {
  margin-top: 6px;
}

.searchFilerCls {
  color: #ff9800 !important;
}

.searchFilerClsN {
  float: right;
  padding-top: 3px;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.text-introduce {
  padding: 20px 24px 24px 30px;
}

.numStyle {
  color: red;
  font-weight: bold;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// HBarChart.vue?668bec76